<template>
    <div class="sideinfo">
        <div class="sidemember" v-if="$store.state.islogin">
            <div class="avatar"><a href="#" @click="isshowavatar=true"><img :src="$common.getavatar( $store.state.avatar)" /></a></div>
            <dl class="meminfo">
                <dt><a href="#">{{$common.basic.strgetlen( $store.state.showname,16)}}</a></dt>
                <dd><a href="#" @click="gopage('profile')">个人信息</a><a href="#" @click="$common.logout()">退出</a></dd>
            </dl>
        </div>


        <div class="sidebtn1">
            <a href="#" @click="gopage('infoedit')"><i class="iconfont icon-fabu"></i>我要投诉</a>
        </div>
        <div class="sidebtn2">
            <a href="#" @click="gopage('home',99)"><i class="iconfont icon-biaoge"></i>我的投诉</a>
        </div>
        <dl class="sidead">
            <dd v-for="item in infolist" :key="item.id">
                <a :href="item.url" target="_blank" :title="item.title"><ffimg :imgsrc="item.img" /></a>
            </dd>
        </dl>

        <el-dialog v-if="isshowavatar && $store.state.islogin" :visible.sync="isshowavatar" top="0px" :append-to-body="true">
            <div class="myavatar modulewrap">
                <div class="title">头像修改</div>
                <div class="con">
                    <ffupload :fileurl="myavatar" @update:fileurl="updateface" :updata="{'mediatype':'avatar'}"></ffupload>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { mixinpage } from "@/mixin/mixin"

    export default {
        name: 'Cside',
        mixins: [mixinpage],
        data() {
            return {
                infolist: [],
                isshowavatar: false,
                myavatar: this.$store.state.avatar
            };
        },
        methods: {
            updateface: function (v) {
                this.myavatar = v;
                this.$store.dispatch('setavatar', this.myavatar);
            }
        },
        mounted() {
            this.$common.fetch({ 'act': 'sht_side', 'msg': '' }, res => {
                this.infolist = res.infodata;
            });

        }
    };
</script>
